import { useGetUserSubscription } from '@forwardflow/hooks/customHooks'
import { useUpdatePaymentModalStore } from '@forwardflow/store/modal/updatePaymentModal'
import Icon from '@forwardflow/ui/Icons'
import { Skeleton } from 'antd'
const cardBrandImages: { [key: string]: string } = {
   visa: '/images/visa.svg',
   mastercard: '/images/master-card.png',
   americanexpress: '/images/amex.svg',
   discover: '/images/discover.svg',
}

export const SavedCards = () => {
   const { data, isLoading } = useGetUserSubscription()
   const { openUpdatePaymentModal } = useUpdatePaymentModalStore()

   const getCardImage = (brand: string) => {
      return cardBrandImages[brand] || '/images/default-card.png'
   }

   return (
      <div className="flex-1">
         <p className="font-medium">Saved Card</p>
         {!isLoading ? (
            <div className="bg-[#474747]/10 min-h-80 flex flex-col justify-between mt-5 rounded-3xl overflow-hidden">
               <div className="bg-[linear-gradient(180deg,#9061DA_0%,#7044B4_100%)] px-7 py-9">
                  <div
                     onClick={openUpdatePaymentModal}
                     className="flex items-center justify-center gap-3 py-5 transition-all rounded cursor-pointer bg-black/20 hover:bg-black/30 mb-7"
                  >
                     <Icon name="Edit" className="scale-110" />
                     <p>Change Card</p>
                  </div>
                  <p className="mb-3 font-medium">
                     {data?.cardDetails?.cardNumber || ''}
                  </p>
                  <div className="flex justify-between text-[10px]">
                     <span>{data?.cardDetails?.nameOnCard || ''}</span>
                     <span>{`${data?.cardDetails?.expMonth || ''}/${
                        data?.cardDetails?.expYear || ''
                     }`}</span>
                  </div>
               </div>
               <div className="flex items-center justify-end flex-1 p-5">
                  <img
                     src={getCardImage(data?.cardDetails?.brand || '')}
                     alt={data?.cardDetails?.brand || ''}
                     className="max-h-7"
                  />
               </div>
            </div>
         ) : (
            <div>
               <Skeleton active className="my-6" />
               <Skeleton active />
            </div>
         )}
      </div>
   )
}
